


































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import RegexValidators from '@/shared/regex-validators';

const cssPrefix = 'change-billing-address';
@Component({
  components: {
    SwTextfield,
    SwButton,
    SwSelect,
    SwIcon,
    SwTitlePane,
  },
  directives: {
    tooltip,
  },
})

export default class ChangeBillingAddress extends SwExtendedVue {

  cssPrefix = cssPrefix;

  @Prop({ required: true })
  customerAddrID: any;

  fullName : any = '';
  addressTab3 : any = '';
  address2Tab3 : any = '';
  city : any = '';
  country :string = '';
  state : string = '';
  province : string = '';
  postalCode : any = '';
  phoneNumber : any  = '';
  email : any = '';
  showCAorUS : boolean = false;
  listOfCountries : any ;
  vatNumber : string = '';
  showVatInfo : boolean = false;
  isSubmitted : boolean = false;
  countryList: SelectOption[] = [];
  statesList : SelectOption[] = [];
  emailValidator = new RegExp(RegexValidators.email);
  phoneNoValidator = new RegExp(RegexValidators.phoneNo);

  countrySelectionChanged(event : any) {
    this.showVatInfo = false;
    console.warn(event);
    this.showCAorUS =  false;
    const ind = this.countryList.findIndex((ele : any) => ele.id === event);
    const index = this.listOfCountries.findIndex((ele : any) => ele.id === event);
    this.showVatInfo = this.listOfCountries[index].isVatRequired;
    if (ind > -1 && this.countryList[ind].value === 'US') {
      this.$store.commit('startLoading');
      this.$store
      .dispatch('MswProductsStoreModule/getStates', { countryCode : 'US' })
      .then((res: any) => {
        this.$store.commit('startLoading');
        console.warn(res);
        this.statesList = res.map((each: any) => {
          return {
            id: each.stateCode,
            label: this.$t(each.stateName),
            value: each.stateCode,
          };
        });
        this.state = this.statesList[0].id;
        this.showCAorUS =  true;
        this.$store.commit('stopLoading');
      });
    } else if (ind > -1 && this.countryList[ind].value === 'CA') {
      this.$store.commit('startLoading');
      this.$store
      .dispatch('MswProductsStoreModule/getStates', { countryCode : 'CA' })
      .then((res: any) => {
        this.$store.commit('startLoading');
        console.warn(res);
        this.statesList = res.map((each: any) => {
          return {
            id: each.stateCode,
            label: this.$t(each.stateName),
            value: each.stateCode,
          };
        });
        this.state = this.statesList[0].id;
        this.showCAorUS =  true;
        this.$store.commit('stopLoading');
      });
    }
  }

  submitBillingInfo() {
    console.warn('submited');
    this.isSubmitted = true;
    if (this.validateAddressInfo()) {
      const address = {
        fullName: this.fullName,
        address1: this.addressTab3,
        address2: this.address2Tab3,
        city: this.city,
        state: this.showCAorUS ? this.state :  '',
        province: this.province,
        country: this.country ? this.countryList.filter((ele : any) => ele.id === this.country)[0].value : '',
        zipcode: this.postalCode,
        phone: this.phoneNumber,
        emailAddress: this.email,
        vatNumber: this.showVatInfo ? this.vatNumber : '',
        enccardetails: '',
        customerAddressId: this.customerAddrID,
        autoRenewalId: '',
      };
      this.$store.commit('startLoading');
      this.$store.dispatch('SnbProfileStoreModule/updateBillingInfo', address)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
        console.warn(res);
      });
    }
  }

  validateAddressInfo() {
    // tslint:disable-next-line:max-line-length
    if (this.fullName.trim() !== '' && this.addressTab3.trim() !== '' && this.city.trim() !== '' && this.country.trim() !== '' && this.postalCode.trim() !== '' && this.phoneNumber.trim() !== '' && this.email.trim() !== '') {
      if (!this.email.match(this.emailValidator) || !this.phoneNumber.match(this.phoneNoValidator)) {
        return false;
      }
      if (!this.showCAorUS && this.province.trim() === '') {
        return false;
      }
      if (this.showVatInfo && this.vatNumber.trim() === '') {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }

  created() {
    Promise.all([
      this.$store.dispatch('SnbProfileStoreModule/getCountriesFromServer', 'NO'),
      this.$store.dispatch('SnbProfileStoreModule/getBillingAddress', this.customerAddrID),
    ])
    .then((resp) => {
      this.fullName = resp[1].content.fullName;
      this.addressTab3 = resp[1].content.address1;
      this.address2Tab3 = resp[1].content.address2;
      this.city = resp[1].content.city;
      if (resp[1].content.country === 'US' || resp[1].content.country === 'CA') {
        this.$store.commit('startLoading');
        this.$store
        .dispatch('MswProductsStoreModule/getStates', { countryCode : resp[1].content.country === 'US' ? 'US' : 'CA' })
        .then((res: any) => {
          this.$store.commit('stopLoading');
          console.warn(res);
          this.statesList = res.map((each: any) => {
            return {
              id: each.stateCode,
              label: this.$t(each.stateName),
              value: each.stateCode,
            };
          });
          const stateInd = this.statesList.findIndex((ele : any) => ele.id === resp[1].content.state);
          if (stateInd > -1) {
            this.state = this.statesList[stateInd].id;
          } else {
            this.state = this.statesList[0].id;
          }
          this.showCAorUS =  true;
          this.$store.commit('stopLoading');
        });
      } else {
        this.province =  resp[1].content.province;
      }
      this.postalCode = resp[1].content.zipcode;
      this.phoneNumber =  resp[1].content.phone;
      this.email =  resp[1].content.emailAddress;
      this.vatNumber = resp[1].content.vatNumber;
      this.listOfCountries = resp[0].content.lstCountries;
      this.listOfCountries.forEach((ele : any) => {
        const inner : any = {};
        inner['id'] = ele.id;
        inner['label'] =  ele.countryName;
        inner['value'] = ele.countryCode;
        this.countryList.push(inner);
      });
      this.country = this.countryList.filter((ele : any) => ele.value === resp[1].content.country)[0].id;
      this.$store.commit('stopLoading');
    });
  }
}
